import Swiper, { Navigation, Pagination, Controller } from 'swiper';
import Glightbox from 'glightbox';

export default (() => {
  $('.thor-catalogue-slider').each(function () {
    const slider = $(this).find('.slider');
    const buttonNext = $(this).find('.swiper-button-next')[0];
    const buttonPrev = $(this).find('.swiper-button-prev')[0];

    const mySwiper = new Swiper(slider.get(0), {
      modules: [Navigation, Controller, Pagination ],
      slidesPerView: 1,
      spaceBetween: 15,
      watchOverflow: true,
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          allowTouchMove: false,
        },
      },
      on: {
        init: function () {
          const lightbox = Glightbox({
            selector: '.thor-catalogue-slider a',
            title: false,
            description: false,
            events: {
              open: function () {
                // Disable Swiper drag events when Glightbox is opened
                mySwiper.allowSlideNext = mySwiper.allowSlidePrev = false;
              },
              close: function () {
                // Enable Swiper drag events when Glightbox is closed
                mySwiper.allowSlideNext = mySwiper.allowSlidePrev = true;
              },
            },
          });
        },
      },
    });
  });
})();



// WEBPACK FOOTER //
// ./scripts/gutenberg/blocks/slider-catalogue.js